export const WIDGET_GET_YOUR_KITS = 'widget-get-your-kits';
export const WIDGET_GET_YOUR_KITS_RESULT = `${WIDGET_GET_YOUR_KITS}/result`;
export const WIDGET_GET_YOUR_KITS_ERROR = `${WIDGET_GET_YOUR_KITS}/error`;
